import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import classes from "./admin.module.css";
import AdminPrograms from "./programs/AdminPrograms";
import AdminDashboard from "./dashboard/AdminDashboard";
import SideBar from "./../../layouts/sideBar/Sidebar";
import UsersTable from "./users/AdminUsers";
import ProgramDetails from "./programs/programDetails/AdminEditProgramDetails";
import AdminCounter from "./counterSection/AdminCounter";
import { NewsLetter } from "./Newsletter/Newsletter";
import SpecialRequests from "./SpecialRequests/SpecialRequests";
import AdminReviews from "./Reviews/AdminReviews";
import "react-quill/dist/quill.snow.css";
import CareersAdmin from "./careers/CareersAdmin";
import BlogsAdmin from "./blogs/AdminBlogs";
import CapacityProjectsAdmin from "./capacity/CapacityProjectsAdmin";
import AdminEvents from "./Events/AdminEvents";
import AdminTeam from "./team/AdminTeam";

const AdminPage = () => {
  return (
    <>
      <div className={classes.container}>
        <SideBar />
        <div className={classes.content}>
          <Routes>
            <Route path="/dashboard" element={<AdminDashboard />} />
            <Route path="/programs">
              <Route index element={<AdminPrograms />} />
              <Route path=":id/*" element={<ProgramDetails />} />
            </Route>
            <Route path="/users" element={<UsersTable />} />
            <Route path="/blogs" element={<BlogsAdmin />} />
            <Route path="/counter" element={<AdminCounter />} />
            <Route path="/newsletter" element={<NewsLetter />} />
            <Route path="/special-requests" element={<SpecialRequests />} />
            <Route path="/reviews" element={<AdminReviews />} />
            <Route path="/careers" element={<CareersAdmin />} />
            <Route path="/events" element={<AdminEvents />} />
            <Route path="/team" element={<AdminTeam />} />
            <Route
              path="/capacity-projects"
              element={<CapacityProjectsAdmin />}
            />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default AdminPage;
